<template>
  <div class="container-reclef">
      <div class="painel">
          <img src="https://www.lefisc.com.br/reclef/img/Revisor da Exclusão do ICMS do PISCOFINS_Prancheta 1@2x.png" alt="planejar" class="planejar-img">
      </div>      
    <div class="area-acesso">
        <p>O RECLEF – PIS e COFINS (Revisor da Exclusão do ICMS da Base de Cálculo do PIS/COFINS), tem como finalidade auxiliar na apuração do PIS/COFINS excedente recolhido sobre o valor do ICMS destacado nos documentos fiscais, através da importação dos documentos fiscais eletrônicos, diante da Decisão do STF – Tema 69 – Repercussão Geral.</p>
        <p style="color:red;font-size:15px;text-align:center"> Não se aplica ao simples nacional</p>
        <div class="duasImg"><a style="margin-right:15px;" href="https://www.youtube.com/watch?v=M4ZpH5yESWw" target="_blank"><img src="https://www.lefisc.com.br/reclef/img/88adbd98-7196-4660-ba0a-597e6dc6c620.jpg" alt="" ></a><a style="margin-left:15px;" href="https://www.youtube.com/watch?v=sfDjjyYzeXc" target="_blank"><img src="https://www.lefisc.com.br/reclef/img/027df6bb-a309-4c51-9e45-364ccf0747f1.jpg" alt="" ></a></div>
        <button class="start-button" @click="continuar">Começar</button>
    </div>        
  </div>
</template>

<script>


export default {
    data(){
        return{
            
        }
    },
    methods:{    
        getCookie(cname) {
            var name = cname + "=";
            var decodedCookie = decodeURIComponent(document.cookie);
            var ca = decodedCookie.split(';');
            for(var i = 0; i < ca.length; i++) {
                var c = ca[i];
                while (c.charAt(0) == ' ') {
                c = c.substring(1);
                }
                if (c.indexOf(name) == 0) {
                return c.substring(name.length, c.length);
                }
            }
            return "";
        },  
        abrir(){
            window.open('https://www.youtube.com/watch?v=tGWTkUmOB-Y','_blank')
        },
       continuar(){
           if(this.getCookie('idCliente') != '9475'){
            this.$router.push({name:'revisar'})
           }
       }
    },
}
</script>

<style >
.start-button {
    margin-top: 40px;
    width: 350px;
    height: 56px;
    background: #af3437;
    color: #fff;
    font-size: 20px;
    font-style: italic;
    border-radius: 5px;
}
.start-button:focus{
    outline: none;
}
.area-acesso{
    background: #fff;
    padding: 25px;
    position: relative;
    top: -70px;
    border-radius: 10px;
    max-width: 1200px;
    margin: 0 auto;
}
.area-acesso .duasImg{
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    margin-top: 40px;
}
.area-acesso p{
    color: #000;
    font-size: 26px;
    font-weight: 700;
    line-height: 30px;
    text-align: justify;
}
.area-acesso .duasImg a {
    height: 173px;
    transition: 0.5s all;
    width: 100%;
    max-width: 300px;
}
.area-acesso .duasImg a img{
    cursor: pointer;
    border-radius: 15px;
    max-width: 280px;
    transition: 0.5s all;
}
.area-acesso .duasImg a img:hover{   
    max-width: 260px;
}
.container-reclef{
    margin:0 auto;
    max-width: 1290px; 
    background: #fff;
    min-height: 100vh;
}
.painel{
    height: 25vw;
    width: 100%;
    max-width: 1300px;
    background-image: url('https://www.lefisc.com.br/reclef/img/fundi-02@2x.png');
    background-size: 100% 120%;
    background-repeat: no-repeat;
    background-color: #f35659;
    background-blend-mode: multiply;
     display: flex;
    align-items: center;
    justify-content: center;
}

</style>
